<template>
    <div style="width: 750px;margin: 0 auto;border:1px solid;box-shadow: 5px 5px 5px #888888;">
        <div id="content" style="width: 650px;margin: 0 auto;">

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt; text-align:center">
                <span style="font-family:华文楷体; font-size:16pt; font-weight:bold">购销协议之补充协议</span>
            </p>

            <p style="margin:0pt; text-align:center">
                <span style="font-family:华文楷体; font-size:15pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt">
                <span style="font-family:华文楷体; font-size:10.5pt">本《购销协议之补充协议》（以下简称“本补充协议”） 由以下双方于</span>

                <span class="content">{{contract.year1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">年</span>

                <span class="content">{{contract.month1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">月</span>

                <span class="content">{{contract.day1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">日</span>

                <span style="font-family:华文楷体; font-size:10.5pt">共同签署：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方：</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">北京果敢时代科技有限公司</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方：</span>
                <span class="content">{{contract.Bname}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt">
                <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方于</span>

                <span class="content">{{contract.year2}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">年</span>


                <span class="content">{{contract.month2}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">月</span>


                <span class="content">{{contract.day2}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">日</span>

                <span style="font-family:华文楷体; font-size:10.5pt">签署了的合同号为</span>
                <span class="content">{{contract.code}}</span>

                <span style="font-family:华文楷体; font-size:10.5pt">的《 购销协议 》（以下简称“主协议”），经双方友好协商，就主协议中的若干事项达成以下共识和一致意见：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt"><span
                    style="font-family:华文楷体; font-size:10.5pt">1．双方同意合作品牌如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">合作品牌：</span>
                <span class="content">{{contract.brand}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">2．双方同意如下结算方式：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">产品经甲方验收入库并完成商品上架之日起 <span class="content">{{contract.days}}</span>天，乙方向甲方申请结算，
                双方确认无误后<span class="content">{{contract.days1}}</span>天内，乙方按主合同发票开具规定向甲方开具发票，
                甲方收到乙方发票后<span class="content">{{contract.days2}}</span>天向乙方支付对应货款。
                </span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
            <span
                    style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">3．乙方银行账户信息如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">户名：</span>
                <span class="content">{{contract.BaccountName}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0"><span
                    style="font-family:华文楷体; font-size:10.5pt">开户行：</span>
                <span class="content">{{contract.Bbank}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">账号：</span>
                <span class="content">{{contract.BaccountNum}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方的银行账户信息如发生任何变化，应提前30日通知甲方，并提供新的银行账户信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">4．为主协议及本补充协议之目的，双方同意如下保证金事项：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方应当在签订本协议后10日内向甲方支付商品质量和服务保证金，该保证金总金额为人民币<span class="content">{{contract.deposit}}</span>元。若乙方未按约定时间支付保证金的，乙方认可甲方有权自应结账款中扣除相应金额作为保证金。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方保证金银行账户信息如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">户名：【北京果敢时代科技有限公司】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">开户行：【招商银行股份有限公司北京望京支行】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">账号：【110915262610114】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">5．双方同意就主协议规定退换货补充规定如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">在不限制甲方根据主协议享有的任何退货权利和补救办法的条件下，
                甲方有权向乙方按照合同期内采购的总货值
                <span class="content">{{contract.ReturnRatio}}</span>%
                退货或更换，相关费用和风险由
                <span class="content">{{contract.BearParty}}</span>
                方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方退货地址：</span>
                <span class="content">{{contract.BreturnAddress}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系人：</span>
                <span class="content">{{contract.BcontactsName}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <span class="content">{{contract.BcontactsPhone}}</span>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方的退货地址如发生任何变化，应提前30日通知甲方，并提供新的退货地址。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">6．为主协议及本补充协议之目的，双方指定如下代理人进行业务沟通：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方指定的代理人：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">姓名：</span>
                <span class="content">{{contract.AagentName}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">地址：</span>
                <span class="content">{{contract.AagentAddr}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">邮箱：</span>
                <span class="content">{{contract.AagentEmail}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <span class="content">{{contract.AagentPhone}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方指定的代理人：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">姓名：</span>
                <span class="content">{{contract.BagentName}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">地址：</span>
                <span class="content">{{contract.BagentAddr}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">邮箱：</span>
                <span class="content">{{contract.BagentEmail}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <span class="content">{{contract.BagentPhone}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">一方的授权代理人信息如发生任何变化，应提前5个工作日通知另外一方，并提供新的联系人信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">7．甲方在合作期限内累计达成以下采购金额的，乙方应当按照以下标准进行返利：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0" v-for="item in contract.rebates">
                <span style="font-family:华文楷体; font-size:10.5pt">累计<span class="content">{{item.moneyType}}</span>达到</span>
                <span class="content">{{item.money}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">元人民币，乙方给予甲方累计<span class="content">{{item.ratioType}}</span></span>
                <span class="content">{{item.ratio}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt">%的返利；</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方有权在应付款项中直接扣除返利金额。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0"><span
                    style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">8．本补充协议是对主协议的补充，是主协议不可分割的一部分，与主协议拥有同等法律效力，主协议内容与本补充协议的约定不一致时，以本补充协议的内容确定双方的权利义务；本补充协议中未涉及的内容依据主协议履行；</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">9．本补充协议自双方盖章之日起生效，一式贰（2）份，双方各执壹（1）份，具有同等法律效力。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-style:italic">[以下无正文]</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>

            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:464.3pt">
                <tr style="height:96.8pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">甲方（盖章）：北京果敢时代科技有限公司</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <span class="content">{{contract.AsignYear}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <span class="content">{{contract.AsignMonth}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <span class="content">{{contract.AsignDay}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">乙方（盖章）：</span>
                            <span class="content">{{contract.Bsign}}</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <span class="content">{{contract.BsignYear}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <span class="content">{{contract.BsignMonth}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <span class="content">{{contract.BsignDay}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:29.3pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <span class="content">{{contract.Adeputy}}</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <span class="content">{{contract.Bdeputy}}</span>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
        </div>
        <div style="padding:20px 0px 15px 0px;text-align: center">
            <el-button type="primary" @click="htmlPrint()">打 印</el-button>
            <el-button type="primary" @click="returnWindow()">返 回</el-button>
        </div>
    </div>
</template>

<script type="text/javascript">
    require('../../../../plugins/jquery.jqprint-0.3.js')
    export default {
        data () {
            return {
                contract: {

                    year1: "年",
                    month1: "月",
                    day1: "日",

                    Bname: "乙方名称",

                    year2: "年",
                    month2: "月",
                    day2: "日",

                    code: "合同编号",
                    brand: "品牌",

                    days:"60",
                    days1:"60",
                    days2:"60",
                    deposit:"10000",

                    ReturnRatio:"111",
                    BearParty:"222",

                    BaccountName: "乙方户名",
                    Bbank: "乙方开户行",
                    BaccountNum: "乙方账号",

                    BreturnAddress: "乙方退货地址",
                    BcontactsName: "乙方联系人",
                    BcontactsPhone: "联系方式",

                    AagentName: "甲方代理人姓名",
                    AagentAddr: "甲方代理人地址",
                    AagentEmail: "甲方代理人邮箱",
                    AagentPhone: "甲方代理人联系方式",

                    BagentName: "乙方代理人姓名",
                    BagentAddr: "乙方代理人地址",
                    BagentEmail: "乙方代理人邮箱",
                    BagentPhone: "乙方代理人联系方式",

                    rebates: [
                        {
                            moneyType:"11",
                            ratioType:"11",
                            money: "金额1",
                            ratio: "返利1"
                        }
                    ],

                    Bsign: "乙方签名",

                    AsignYear: "甲方签约年",
                    AsignMonth: "甲方签约月",
                    AsignDay: "甲方签约日",

                    BsignYear: "乙方签约年",
                    BsignMonth: "乙方签约月",
                    BsignDay: "乙方签约日",

                    Adeputy: "甲方代表人",
                    Bdeputy: "乙方代表人"

                }
            }
        },
        mounted () {
            var contentId = this.$route.query.contentId;
            var type = this.$route.query.type;
            this.initContent(contentId, type);
        },
        methods: {
            returnWindow(){
                window.close();
            },
            htmlPrint(){
                $("#content").jqprint();
            },
            initContent(contentId, type){
                var that = this;
                $.get({
                    url: '/suppliers/contract/template/content',
                    data: {
                        contentId: contentId,
                        type: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.contract = result.data;
                        } else {

                        }
                    }
                })
            }
        }
    }
</script>
<style type="text/css" lang="less" scoped>
    .content {
        font-family: 华文楷体;
        font-size: 10.5pt;
        border-bottom: 1px solid #ff4a7d;
    }
</style>



// WEBPACK FOOTER //
// contract_5_1.vue?58a8e714